import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { TextField, CircularProgress } from "@mui/material";
import { Typography, Autocomplete } from "@mui/material";
import { useTranslation } from "react-i18next";
import { filterOptions, useDebounce } from "../../../helpers";
import { userService } from "../../../services";
import { useSnackbar } from "notistack";

const PREFIX = "ExparienceInformations";

const classes = {
  mainTitle: `${PREFIX}-mainTitle`,
  autocomplete: `${PREFIX}-autocomplete`,
};

const StyledDiv = styled("div")(({ theme }) => ({
  [`& .${classes.mainTitle}`]: {
    [theme.breakpoints.up("sm")]: {
      textAlign: "center",
    },
    marginBottom: "1rem",
  },

  [`& .${classes.autocomplete}`]: {
    maxWidth: "650px",
    margin: "0 auto",
  },
}));

const ExparienceInformations = (props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [fetching, setFetching] = useState(false);
  const [fetchedUsers, setFetchedUsers] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const debouncedInput = useDebounce(inputValue, 500);

  useEffect(() => {
    if (inputValue.length > 0) {
      setFetching(true);
      userService
        .searchUser(inputValue)
        .then((res) => {
          setFetchedUsers(res);
        })
        .catch((err) => {
          if (err === 403)
            enqueueSnackbar(t("toasts.unauthorizedError"), {
              variant: "error",
            });
          else enqueueSnackbar(t("toasts.unknownError"), { variant: "error" });
        })
        .finally(() => setFetching(false));
    }
  }, [debouncedInput]);

  const handleUsers = (value) => {
    setInputValue("");
    setFetchedUsers([]);
    let tmp = { ...props.exparience };
    tmp.userDetails = value;
    tmp.users = value.map((user) => user.id);
    props.setExparience(tmp);
  };

  return (
    <StyledDiv sx={{ marginBottom: "20px" }}>
      <Typography variant="h5" className={classes.mainTitle}>
        {t("exparienceCreateForm.authorizationsMenu")}
      </Typography>
      <Autocomplete
        label="users"
        id="autocomplete-users"
        disableClearable
        multiple
        disabled={!props.isAdmin}
        className={classes.autocomplete}
        loading={fetching}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        options={fetchedUsers}
        getOptionLabel={(option) => option.login}
        filterOptions={filterOptions}
        defaultValue={props.exparience.userDetails}
        value={props.exparience.userDetails}
        onChange={(e, value) => handleUsers(value)}
        inputValue={inputValue}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t("exparienceCreateForm.searchAnUser")}
            onChange={(e) => setInputValue(e.target.value)}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {fetching ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </StyledDiv>
  );
};

export default ExparienceInformations;
